import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RentalPage } from './rental.page';

const routes: Routes = [
  {
    path: '',
    component: RentalPage
  },
  {
    path: 'rental-details',
    loadChildren: () => import('./rental-details/rental-details.module').then( m => m.RentalDetailsPageModule)
  },
  {
    path: "add",
    loadChildren: () =>
      import("./rental-details/rental-details.module").then(
        (m) => m.RentalDetailsPageModule
      ),
      data: {
        breadcrumb: 'RENTAL.NEW_ITEM'
      },
  },
  {
    path: "edit/:itemId",
    loadChildren: () =>
      import("./rental-details/rental-details.module").then(
        (m) => m.RentalDetailsPageModule
      ),
      data: {
        breadcrumb: 'RENTAL.EDIT_ITEM'
      },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RentalPageRoutingModule {}
